'use strict';

const STATE = {
  PREPARATION: 'preparation',
  ORDERED: 'ordered',
  STANDBY: 'standby',
  PICKUPED: 'pickuped',
  PACKAGED: 'packaged',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  REFUNDED: 'refunded',
  PENDING: 'pending',
  CANCEL_REQUESTED: 'cancel_requested',
  RETURNED: 'returned'
};

const STATE_PATTERN = Object.keys(STATE).map((key) => STATE[key]);

const DISPLAY_STATE = {
  BACK_ORDERED: 'Back-ordered',
  PRE_ORDERED: 'Pre-ordered',
  ORDERED: 'Ordered',
  SHIPPING_SOON: 'Shipping Soon',
  PACKAGED: 'Packaged (handed off to shipping services)',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  PENDING: 'Pending',
  REFUNDED: 'Refunded',
  RETURNED: 'Returned',
  REVIEWED: 'Reviewed'
};

const DISPLAY_STATE_PATTERN = Object.keys(DISPLAY_STATE).map(
  (key) => DISPLAY_STATE[key]
);

const PENDING_METHODS = {
  NOTE: 'note',
  SECURITY: 'security',
  PRE_ORDERED: 'pre_ordered',
  MULTIPLE_ACCOUNTS: 'multiple_accounts',
  // 配送引受停止中
  SUSPEND_TRANSPORTATION: 'suspend_transportation',
  // Refund待ち
  WAITING_REFUND: 'waiting_refund',
  // Customer SupportやDevチーム確認待ち
  WAITING_CONFIRMATION: 'waiting_confirmation',
  // 分割が必要
  NEED_SPLIT_ITEMS: 'need_split_items',
  // 関税支払い待ち
  WAITING_TARIFF_PAYMENT: 'waiting_tariff_payment'
};

const PENDING_METHODS_PATTERN = Object.keys(PENDING_METHODS).map(
  (key) => PENDING_METHODS[key]
);

module.exports = {
  STATE,
  STATE_PATTERN,
  DISPLAY_STATE,
  DISPLAY_STATE_PATTERN,
  PENDING_METHODS,
  PENDING_METHODS_PATTERN
};
